import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldCheck2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconShieldCheck2"><Path d="M9.5 12.25L11 13.75L14.5 10.25M6.75 3.75H17.25C18.9069 3.75 20.25 5.09315 20.25 6.75V15.9691C20.25 17.0669 19.6503 18.0771 18.6866 18.6028L13.4366 21.4664C12.5411 21.9548 11.4589 21.9548 10.5634 21.4664L5.31344 18.6028C4.34966 18.0771 3.75 17.0669 3.75 15.9691V6.75C3.75 5.09315 5.09315 3.75 6.75 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconShieldCheck2;
